import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import type { CoinMode } from '@ui/hooks/useCoinMode';
import { coinModes, coinModesCro, useCoinMode } from '@ui/hooks/useCoinMode';
import { ZKSYNC_ENABLED } from '@veno-app/wallet';
import type { ReactNode } from 'react';

import { Card } from './Card';

export type CoinModeSwitchTabProps = Omit<FlexProps, 'children'> & {
  coinMode?: CoinMode;
  onCoinModeChange: (coinMode: CoinMode) => void;
  children: (coinMode: CoinMode) => ReactNode;
};
export const CoinModeSwitchTab = ({
  coinMode: _coinMode,
  onCoinModeChange,
  children,
  ...props
}: CoinModeSwitchTabProps) => {
  const globalCoinMode = useCoinMode();
  const coinMode = _coinMode ?? globalCoinMode;

  return (
    <Flex direction="column" gap="4px" w="170px" flexShrink="0" {...props}>
      {(ZKSYNC_ENABLED ? coinModes : (coinModesCro as CoinMode[])).map(
        (itemCoinMode, i) => {
          const isActive = itemCoinMode === coinMode;
          return (
            <Card
              key={i}
              variant="button"
              isActive={isActive}
              cursor="pointer"
              textStyle="h4Bold"
              color={isActive ? 'text-active' : 'text-inactive'}
              p="10px"
              textAlign="center"
              justifyContent="center"
              onClick={() => {
                onCoinModeChange(itemCoinMode);
              }}
            >
              {children(itemCoinMode)}
            </Card>
          );
        },
      )}
    </Flex>
  );
};
